module.exports = __webpack_public_path__ + "img/mini-007.dbc2c037.jpg";